<!-- 添加企业应用弹框内容 -->
<template>
  <el-dialog
    title="添加企业应用"
    :visible="dialogVisible"
    width="560px"
    :show-close="true"
    :close-on-click-modal="false"
    :popper-append-to-body="true"
    :destroy-on-close="true"
    @close="handleClose"
  >
    <div class="model_con">
      <p v-if="isedit">需要将图文消息中的图片同步到素材库中，请选择适用的公众号</p>
      <p v-else>企业应用</p>
      <el-select v-model="value" multiple class="select" placeholder="请添加企业应用">
        <template v-for="item in agentList">
          <el-option
            :key="item.agent_id"
            :label="item.agent_name"
            :value="{ value: item.agent_id, label: item.agent_name }"
            :disabled="+item.close === 1"
          />
        </template>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="handleBtn">确定</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'AddNoPublic',
  components: {},
  props: {
    isedit: {
      type: Boolean,
      default: false,
    },
    // 盒子状态
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    agentValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: [],
    };
  },
  computed: {
    agentList() {
      return this.$store.state.user.managerLogin.agent_list || [];
    },
  },
  watch: {
    agentValue(newval) {
      this.value = JSON.parse(JSON.stringify(newval));
    },
    // 关闭盒子清空数据
    async dialogVisible(newVal) {
      if (newVal) {
        this.value = this.agentValue;
      } else {
        this.value = [];
      }
    },
  },
  mounted() {
    this.value = JSON.parse(JSON.stringify(this.agentValue));
  },
  methods: {
    handleBtn() {
      const { value } = this;
      if (value.length === 0) {
        this.$message('请选择企业应用');
        return;
      }
      this.$emit('emitUserAgent', value);
      this.handleClose();
    },
    // 关闭盒子 清空数据
    handleClose() {
      this.$emit('update:dialogVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 20px;
  .el-dialog__title {
    font-size: 16px;
    color: #303133;
    line-height: 22px;
  }
  // 名称和关闭按钮
  .title-warp {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 16px;
    }
    .icon-guanbi {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
.model_con {
  padding: 10px 120px 24px 120px;
  p {
    font-size: 16px;
    color: #303133;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 6px;
  }
  .btn {
    width: 128px;
    height: 48px;
    display: block;
    margin: 32px auto 0 auto;
  }
  .select {
    width: 100%;
    font-size: 16px;
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
</style>
